<script setup>
import gsap from '~/vendors/gsap'

const componentRef = ref(null)
let tl
const isActive = ref(false)
function onEnter() {
  isActive.value = true
}

watch(isActive, (value) => {
  if (value) {
    tl.play()
  }
})

onMounted(() => {
  const el = componentRef.value.$el
  const windowWidth = window.innerWidth
  const { left } = el.getBoundingClientRect()
  const delay = (left / windowWidth) * 0.25
  tl = gsap.timeline({ paused: true }).from(
    el,
    {
      opacity: 0,
      rotateX: 117,
      rotateY: 7,
      rotateZ: 9,
      y: '33%',
      scale: 0.8,
      duration: 1,
      ease: 'power2.out',
      transformOrigin: 'left top',
      clearProps: 'transform',
    },
    delay
  )
})

onBeforeUnmount(() => {
  tl?.kill()
})
</script>

<template>
  <InView class="animated-card" ref="componentRef" @enter="onEnter">
    <slot />
  </InView>
</template>

<style lang="scss">
.animated-card {
}
</style>
